import React from 'react';

import map from 'lodash/map';

import {
  LegacyBox,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@gogame/components';
import { useParams } from '@gogame/screens';

import { useValidationErrorsByPath } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Validation';
import { useViewStateByPath } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/ViewState';

import BudgetValues from './BudgetValues';
import Item from './Item';
import { TreeItemsDepth } from './TreeItemsDepth';
import {
  TreeWrapper,
  TreePaper,
  ItemTitleLinkRouter,
  TotalItemBox,
  TotalTitleText,
  ButtonToggle,
  DividerVertical,
} from './components';

const ItemTitleLink = ({ children, withLink }) => {
  return withLink ? (
    <ItemTitleLinkRouter to={''}>{children}</ItemTitleLinkRouter>
  ) : (
    children
  );
};

const Tree = ({ renderIndicatorTotal, renderIndicatorCell }) => {
  const params = useParams();
  const isPathExist = !!params['*'];
  const levelPath = isPathExist ? `${params.year}/${params.month}` : '';
  const { nodes, activityTypes, metricTypes } = useViewStateByPath();
  const { activityTypes: activityTypesErrors } = useValidationErrorsByPath();

  const [openTree, setOpenTree] = React.useState(true);

  const handlerOnShow = React.useCallback(() => {
    setOpenTree((state) => !state);
  }, []);

  return (
    <TreeWrapper dataOpenTree={openTree} data-cy={'Tree'}>
      {openTree ? (
        <TreePaper variant={'outlined'}>
          <ItemTitleLink to={''} withLink={levelPath}>
            <TotalItemBox align={'center'}>
              <LegacyBox grow={1}>
                <TotalTitleText link={isPathExist}>Total Budget</TotalTitleText>
              </LegacyBox>
              <LegacyBox vertical={true} gutter={4}>
                {map(activityTypes, ({ budget, budgetAllocated }, type) => (
                  <BudgetValues
                    key={type}
                    type={type}
                    budget={budget}
                    budgetAllocated={budgetAllocated}
                    budgetAllocatedError={
                      activityTypesErrors?.[type].budgetAllocated
                    }
                    renderIndicator={renderIndicatorTotal}
                  />
                ))}
              </LegacyBox>
            </TotalItemBox>
          </ItemTitleLink>
          <TableContainer>
            <Table
              size={'small'}
              stickyHeader={true}
              leftStickyColumnCount={2}
              name={'treeTable'}
            >
              <TableHead>
                <TableRow>
                  <TableCell columnTitle={'Networks'}>Networks</TableCell>
                  <TableCell padding={'none'} />
                  <TableCell columnTitle={'cBudget'} align={'right'}>
                    cBudget
                  </TableCell>
                  <TableCell columnTitle={'Budget'} align={'right'}>
                    Budget
                  </TableCell>
                  {metricTypes.map(({ name }, i) => (
                    <TableCell key={i} align={'right'} columnTitle={`c${name}`}>
                      {`c${name}`}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                <TreeItemsDepth nodes={nodes}>
                  {({
                    to,
                    node,
                    path,
                    current,
                    currentParent,
                    open,
                    last,
                    onClickLink,
                  }) => (
                    <Item
                      to={to}
                      node={node}
                      current={current}
                      currentParent={currentParent}
                      open={open}
                      last={last}
                      renderIndicator={renderIndicatorCell}
                      onClickLink={onClickLink}
                      path={path}
                    />
                  )}
                </TreeItemsDepth>
              </TableBody>
            </Table>
          </TableContainer>
        </TreePaper>
      ) : null}
      <div>
        <ButtonToggle onClick={handlerOnShow}>
          <DividerVertical />
          {openTree ? (
            <ChevronLeftIcon color={'action'} />
          ) : (
            <ChevronRightIcon color={'action'} />
          )}
          <DividerVertical />
        </ButtonToggle>
      </div>
    </TreeWrapper>
  );
};

export default Tree;
